import React, { useContext } from 'react';
import { TrashIcon } from '../../../UI/Images/Icons';
import { getFullDate, getTime } from '../../../../utils/dateTimeUtil';
import { useHistory, useParams } from 'react-router';
import { makeStyles } from '@material-ui/core';
import useCheckMobileScreen from '../../../../hooks/useWidth';
import ArrowIcon from '../../../../assets/images/Icon/arrowMobile.svg';
import MessagesContext from '../../../../contexts/messagesContext';
import { PropTypes } from 'prop-types';
import LanguageContext from '../../../../contexts/languageContext';
import SelectionForm from '../SelectionForm';
import PrintFormStructure from './PrintFormStructure';
import { useSelector } from 'react-redux';

const styles = makeStyles((theme) => ({
    row: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
        // position: 'relative',
        // top: '35px',
    },
    dateWrapper: {
        display: 'flex',
        alignItems: 'center'
        // margin: "0 5px"
    },
    date: {
        // fontSize: '15px',
        // fontWeight: '500',
        // textalign: 'center',
        color: '#363636',
        marginInlineEnd: '10px'
    },
    back: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        '& img': {
            margin: '0 5px',
            transform: (props) => (props.rtl ? 'rotateY(0deg)' : 'rotateY(180deg)')
        }
    },
    actionWrapper: {
        marginInlineStart: 'auto'
    },
    printWrapper: {
        marginInlineStart: '10px'
    },
    deleteTitle: {
        color: '#ee384e',
        marginInlineStart: '3px'
    },
    overallInfo: {
        display: 'flex',
        alignItems: 'center',
        flexFlow: 'wrap',
        lineHeight: '2',
        [theme.breakpoints.down(1025)]: {
            justifyContent: 'space-between'
        }
    },
    info: {
        marginBottom: '6px'
    },
    title: {
        marginInlineEnd: '10px'
    },
    newFormHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    editor: {
        marginInlineEnd: '6px'
    }
}));

const FormStructureHeader = ({
    formStructure,
    entry,
    state,
    notEditClinical,
    handleDeleteForm
}) => {
    const isMobile = useCheckMobileScreen();
    const { messages } = useContext(MessagesContext);
    const { lang } = useContext(LanguageContext);
    const classes = styles({ rtl: lang === 'fa' });
    const history = useHistory();
    const params = useParams();
    const path = `/${params.clinicId}/patient/${params.id}/forms/form`;
    const formId = +params?.form_id;
    const allForms = useSelector((state) =>
        state.dynamicForms.allForms?.map((item) => ({ id: item.name, name: item.title }))
    );
    const handleChangeForm = (name) => {
        const findName = allForms?.find((item) => item.id === name);
        // dispatch(getFormStructureNew(name));
        const locationState = { isNew: true, id: formId, title: findName?.name };
        if (findName) {
            history.replace({
                pathname: `${path}/${findName?.id}`,
                state: locationState
            });
        }
        // setDialog(true);
        // setUnBlock(false);
    };

    return (
        <>
            {state?.isNew && isMobile ? (
                <SelectionForm
                    optionsLabel="name"
                    formTitle={state}
                    options={allForms}
                    handleSelectForm={(name) => handleChangeForm(name)}
                />
            ) : state?.isNew ? (
                <div className={classes.newFormHeader}>
                    <h3 className={classes.title}>{formStructure?.title}</h3>
                    <span className={classes.back} onClick={() => history.push(`${path}/newForm`)}>
                        {messages.back}
                        <img src={ArrowIcon} />
                    </span>
                    {/* <h2>{title}</h2> */}
                </div>
            ) : (
                <div className={classes.overallInfo}>
                    <h3 className={classes.title}>{formStructure?.title}</h3>
                    <div className={`${classes.row} ${classes.info}`}>
                        {entry?.last_editor?.first_name && (
                            <div className={`${classes.row} ${classes.editor}`}>
                                <span>
                                    {messages.editedBy} {entry?.last_editor?.first_name}{' '}
                                    {entry?.last_editor?.last_name}
                                </span>
                            </div>
                        )}
                        <div className={classes.dateWrapper}>
                            <span className={classes.date}>{getTime(entry?.created)}</span>
                            <span className={classes.date}>{getFullDate(entry?.created)}</span>
                        </div>
                    </div>
                    <div className={`${classes.actionWrapper} ${classes.row}`}>
                        <div className={classes.row}>
                            <TrashIcon
                                onClick={handleDeleteForm}
                                data-testid="trashIcon"
                                disabled={notEditClinical}
                            />
                            <span className={classes.deleteTitle}>{messages.delete}</span>
                        </div>
                        {!isMobile && (
                            <div className={classes.printWrapper}>
                                <PrintFormStructure entry={entry} />
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};
FormStructureHeader.propTypes = {
    formStructure: PropTypes.object,
    entry: PropTypes.object,
    state: PropTypes.object,
    handleDeleteForm: PropTypes.func,
    notEditClinical: PropTypes.bool
};
export default FormStructureHeader;
